/**
 * The chat a route opens, for the speculative first bootstrap the shell takes on load.
 *
 * A Space answers in one unified chat, its main thread, so the route no longer names a bot or
 * a group: the API resolves Space.mainThreadId itself. Legacy `/app/:botId` and
 * `/app/g/:groupId` links redirect to `/app` before the shell mounts, so no route selects one.
 */
export function initialBootstrapTarget(
  pathname: string,
  desktop: boolean,
): { botId?: string } | null {
  const appRoute = pathname === "/app" || pathname.startsWith("/app/");
  if (!appRoute && !(desktop && pathname === "/")) return null;
  return { botId: undefined };
}
